import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BillingModalComponent } from './billing-modal.component';
import { BannerModule, ButtonModule, CheckboxModule, DropdownModule, InputsModule, RadioModule, TagsModule } from '@xref/xref-lib';
import { LoaderModule } from '../loader/loader.module';
import { StripeService } from '../../services/stripe/stripe.service';

@NgModule({
  declarations: [BillingModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    BannerModule,
    ButtonModule,
    RadioModule,
    CheckboxModule,
    DropdownModule,
    InputsModule,
    TagsModule,
    LoaderModule,
  ],
  exports: [BillingModalComponent],
  providers: [StripeService],
})
export class BillingModalModule {}
